<template>
  <section class="form__content">
    <h3>6. {{ $t('authorization.title') }}</h3>
    <p v-html="content"/>

    <v-form v-model="formValidation">
      <v-checkbox v-if="doctoral"
                  :label="$t('authorization.doctoralAuthorization')"
                  :value="doctoralAuthorization"
                  @change="$emit('update:doctoralAuthorization', $event)"
                  required
                  :rules="[v => !!v || $t('error.authorizationRequired')]"
      />
      <v-checkbox v-if="mui"
                  :label="$t('authorization.authorization')"
                  :value="muiAuthorization"
                  @change="$emit('update:muiAuthorization', $event)"
                  required
                  :rules="[v => !!v || $t('error.authorizationRequired')]"
      />
      <v-checkbox v-if="crous"
                  :label="$t('authorization.legalNoticeDormitory')"
                  :value="legalNoticeDormitory"
                  @change="$emit('update:legalNoticeDormitory', $event)"
                  required
                  :rules="[v => !!v || $t('error.authorizationRequired')]"
      />
      <v-checkbox v-if="crous"
                  :label="$t('authorization.legalNoticeCROUS')"
                  :value="legalNoticeCROUS"
                  @change="$emit('update:legalNoticeCROUS', $event)"
                  required
                  :rules="[v => !!v || $t('error.authorizationRequired')]"
      />
    </v-form>
  </section>
</template>

<script>
export default {
  name: 'Authorization',

  props: {
    valid: {
      required: true,
    },
    doctoral: {
      required: false,
      default: false,
    },
    doctoralAuthorization: {
      required: false,
      default: false,
    },
    content: {
      required: true,
    },
    muiAuthorization: {
      required: false,
      default: false,
    },
    mui: {
      required: false,
      default: false,
    },
    crous: {
      required: false,
      default: false,
    },
    legalNoticeDormitory: {
      required: false,
      default: false,
    },
    legalNoticeCrous: {
      required: false,
      default: false,
    },
  },

  data: () => ({
    formValidation: false,
  }),

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
  },
}
</script>
